import axiosIns from '@/libs/axios'

const ROOT_URL = '/pos_installments'
export default {
  namespaced: true,
  state: {
    customerInstallments: [],
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      title: null,
      installment: null,
      rate: null,
      is_private: 0,
      id_customers: null,
      id_pos_configs: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    loading: false,
  },
  getters: {
    customerInstallments(state) {
      return state.customerInstallments
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_CUSTOMER_INSTALLMENTS(state, data) {
      state.customerInstallments = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        installment: null,
        rate: null,
        is_private: 0,
        id_customers: null,
        id_pos_configs: null,
        id_users: null,
      }
    },
  },
  actions: {
    getCustomerInstallments({ commit }, params) {
      commit('SET_LOADING', true)
      axiosIns
        .post(`${ROOT_URL}/customerInstallments`, params)
        .then(response => {
          commit('SET_CUSTOMER_INSTALLMENTS', response.data.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('SET_LOADING', true)
      const data = {
        where: {
          'pos_installments.id': id,
        },
        array: false,
      }
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/saveData`, params)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    saveBatchData({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/saveBatchData`, params)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    cloneInstallments({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/cloneInstallments`, params)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    resetInstallments({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/resetInstallments`, params)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
